import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCheck, FaArrowLeft } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Navbar from '../components/Navbar';
import './ServicePage.css';

const TechnicalConsulting = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      offset: 100
    });
    window.scrollTo(0, 0);
  }, []);

  const services = [
    'Architecture design & review',
    'Technology stack selection',
    'Scalability planning',
    'Security assessment',
    'Performance optimization',
    'Code review & best practices',
    'DevOps & deployment strategy',
    'Technical documentation'
  ];

  return (
    <div className="service-page">
      <Navbar />
      <div className="service-hero">
        <Link to="/" className="back-button" data-aos="fade-right">
          <FaArrowLeft /> Back to Home
        </Link>
        <div className="service-hero-content" data-aos="fade-up">
          <h1 className="service-page-title">Technical Consulting</h1>
          <p className="service-hero-tagline">Expert guidance to optimize your development process and architecture.</p>
        </div>
      </div>

      <div className="service-content">
        <div className="service-section" data-aos="fade-up">
          <h2 className="section-heading">Overview</h2>
          <p className="section-text">
            Our technical consulting services provide expert guidance on architecture, scalability, security, and best practices. 
            We help you make informed decisions and optimize your development process for long-term success.
          </p>
        </div>

        <div className="service-section" data-aos="fade-up">
          <h2 className="section-heading">Services Offered</h2>
          <div className="features-grid">
            {services.map((service, index) => (
              <div key={index} className="feature-item" data-aos="fade-up" data-aos-delay={index * 50}>
                <FaCheck className="check-icon" />
                <span>{service}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="service-cta" data-aos="fade-up">
          <Link to="/contact" className="cta-button-primary">
            Get Started →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TechnicalConsulting;

